import script from "./PendingSubstanceTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingSubstanceTableRow.vue?vue&type=script&setup=true&lang=js"

import "./PendingSubstanceTableRow.vue?vue&type=style&index=0&id=6f6c8004&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f6c8004"]])

export default __exports__